export function capitalizeFilter () {
	return (input) => {
		if (input) {
			return input.charAt(0).toUpperCase() + input.slice(1);
		}
	};
}
